module.exports = __webpack_public_path__ + "img/profile-circle-1.9a6e7e80.svg";